// extracted by mini-css-extract-plugin
export default {"studentLiveContainer":"student-live_studentLiveContainer__3J5A6","questionContent":"student-live_questionContent__ptFqp","questionActions":"student-live_questionActions__ECdbo"};